
import Vue, { PropType } from 'vue';

// Components
import Select, { SelectOption } from '~/components/builders/Base/Select.vue';
import { SchoolVerification, SchoolVerificationState } from '~/services/types/school';
import { RestXReactiveData } from '~/utils/types';

// Constants
const VALUE_NONE = '';

export default Vue.extend({
    name: 'VerifiedSchoolsSelect',
    components: {
        Select,
    },
    props: {
        value: {
            type: String as PropType<SchoolVerification['schoolId'] | ''>,
            default: '',
        },
        placeholder: {
            type: String as PropType<string | undefined>,
            default: undefined,
        },
        none: {
            type: Boolean as PropType<boolean>,
            default: false,
        },
    },
    computed: {
        selected(): SchoolVerification | null {
            return this.data.find(school => school.schoolId.toString() === this.value) || null;
        },
        verifiedSchools(): RestXReactiveData<SchoolVerification[]> {
            return this.$interfaces.university.connection.get({
                reactive: true,
            }) as RestXReactiveData<SchoolVerification[]>;
        },
        data(): SchoolVerification[] {
            return this.verifiedSchools.data || [];
        },
        options(): SelectOption<string, SchoolVerification['school']>[] {
            const options: SelectOption[] = this.data
                .filter(school => school.state === SchoolVerificationState.verified)
                .map((school: SchoolVerification) => ({
                    label: school.school.name,
                    value: school.schoolId.toString(),
                    extra: school.school || {},
                }));

            if (this.none && this.value !== VALUE_NONE) {
                options.unshift({
                    label: this.$t(
                        'components.miscellaneous.verifiedSchoolDropdown.none'
                    ).toString(),
                    value: VALUE_NONE,
                });
            }

            return options;
        },
        placeholderLabel(): string {
            if (this.placeholder) {
                return this.placeholder;
            }

            return this.$t(
                'components.miscellaneous.verifiedSchoolDropdown.placeholder'
            ).toString();
        },
    },
    methods: {
        handleChange(value: string) {
            if (this.none && value === VALUE_NONE) {
                this.$emit('input', '');
                return;
            }
            this.$emit('input', value);
        },
    },
});
